import Liveness from './Liveness';

function App() {
  return (
    <div className="App">
      <Liveness />
    </div>
  );
}

export default App;
